import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import useAuth from "src/hooks/useAuth";
import { Redirect } from "react-router-dom";
import { PATH_PAGE } from "src/routes/paths";
import LoadingScreen from "src/components/LoadingScreen";
import { setWithListener } from "src/redux/slices/settings";
import { getInitialize } from "src/redux/slices/authJwt";
import jwtDecode from "jwt-decode";
import useResponsive from "src/hooks/useResponsive";
import { useSelector } from "src/redux/store";
import {
  GetZonas,
  getFirstMesaSuccess,
  getMesas,
} from "src/redux/slices/mesas";
import { checkIfAccessTokenIsCloseToExpire } from "src/utils/utils";

// ----------------------------------------------------------------------

AuthProtect.propTypes = {
  children: PropTypes.node,
};

function AuthProtect({ children }) {
  const { isLoading, isAuthenticated } = useAuth();
  const { session } = useSelector((state) => state.authJwt);
  const { mesa } = useSelector((state) => state.mesas);
  const { user } = useSelector((state) => state.authJwt);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isAuthenticated) {
      if (checkIfAccessTokenIsCloseToExpire(24)) dispatch(getInitialize());
    }
  }, []);

  useEffect(() => {
    if (user?.isOnlyTpv) {
      if (!mesa) {
        dispatch(getFirstMesaSuccess());
      }
    }
  }, []);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (session && !session?.isOnlyQr) {
      window.open("https://takemyorder.es", "_self");
    }

    return <Redirect to={PATH_PAGE.auth.login} />;
  }

  return <>{children}</>;
}

export default AuthProtect;
